import * as React from "react";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import LeadStatus from "../../../model/lead/LeadStatus";
import MultiSelectList from "../../../hiberUiKit/src/molecules/MultiSelectList/MultiSelectList";
import {WorkspaceFilterReduxProps} from "./WorkspaceFilter";
import JobStatus from "../../../model/job/JobStatus";
import MultiSelectWorkspaceFilter from "./MultiSelectWorkspaceFilter";

class JobStatusFilter extends MultiSelectWorkspaceFilter<JobStatus> {
	renderContent(items: JobStatus[]): JSX.Element {
		return (
			<div className={"c-filter-status-input-container"}>
				<MultiSelectList items={items}
								 itemToId={(item: JobStatus) => item.id}
								 itemToLabel={(item: JobStatus) => item.label}
								 selectedItemIds={this.getSelectedItems().map(s => s.id)}
								 onUpdate={this.onChange}
								 updateOnChange
								 componentBetweenInputAndList={this.getNegationCheckbox()}/>
			</div>
		)
	}

	itemToId(item: JobStatus): string {
		return item.id;
	}

	itemToLabel(item: JobStatus): string {
		return item.getStatusLabel()
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.jobStatus.jobStatuses
	}
}

export default connect<WorkspaceFilterReduxProps<LeadStatus>>(mapStateToProps)(JobStatusFilter)